import styled from '@emotion/styled';
import * as colors from '@airwallex/colors';
export const CurrencyConversionWrapper = styled.div`
  display: flex;
  position: relative;
  &::before {
    position: absolute;
    left: 8px;
    top: 1px;
    content: '';
    width: 1px;
    height: 12px;
    border-left: 1px solid ${colors.grays[20]};
  }
  &::after {
    bottom: 1px;
    left: 8px;
    position: absolute;
    content: '';
    width: 1px;
    height: 12px;
    border-left: 1px solid ${colors.grays[20]};
  }
`;
